module.exports = __webpack_public_path__ + "static/media/help-blue.eedb546b.svg";